import DiscussionSettings from './DiscussionSettings.svelte';

export let DiscussionWidgetApi = {
  Settings: (target, widget, onChange, refreshUI) => {
    return new DiscussionSettings({
      target: target,
      props: { widget: widget, onChange: onChange, refreshUI: refreshUI }
    });
  }
};
